export default "__VITE_ASSET__CQyhZeiY__"